/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetApplications: BridgeCommands.Command<
    {},
    Types.Gfe.Localgames.GetApplicationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetApplications',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterApplicationChangedNotifications: BridgeCommands.Command<
    {},
    Types.Gfe.Localgames.RegisterApplicationChangedNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'RegisterApplicationChangedNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterApplicationRemovedNotifications: BridgeCommands.Command<
    {},
    Types.Gfe.Localgames.RegisterApplicationRemovedNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'RegisterApplicationRemovedNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StartApplicationScan: BridgeCommands.Command<
    Types.Gfe.Localgames.StartApplicationScanParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'StartApplicationScan',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterApplicationScanProgressNotifications: BridgeCommands.Command<
    {},
    Types.Gfe.Localgames.RegisterApplicationScanProgressNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'RegisterApplicationScanProgressNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetLastApplicationScanTime: BridgeCommands.Command<
    {},
    Types.Gfe.Localgames.GetLastApplicationScanTimeReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetLastApplicationScanTime',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const LaunchApplication: BridgeCommands.Command<
    Types.Gfe.Localgames.LaunchApplicationParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'LaunchApplication',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetLauncherPID: BridgeCommands.Command<
    {},
    Types.Gfe.Localgames.GetLauncherPIDReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetLauncherPID',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetApplicationSearchPaths: BridgeCommands.Command<
    {},
    Types.Gfe.Localgames.GetApplicationSearchPathsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetApplicationSearchPaths',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const AddApplicationSearchPath: BridgeCommands.Command<
    Types.Gfe.Localgames.AddApplicationSearchPathParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'AddApplicationSearchPath',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RemoveApplicationSearchPath: BridgeCommands.Command<
    Types.Gfe.Localgames.RemoveApplicationSearchPathParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'RemoveApplicationSearchPath',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetVOPSStatus: BridgeCommands.Command<
    Types.Gfe.Localgames.GetVOPSStatusParameters,
    Types.Gfe.Localgames.GetVOPSStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetVOPSStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetVOPSSettingsInfo: BridgeCommands.Command<
    Types.Gfe.Localgames.GetVOPSSettingsInfoParameters,
    Types.Gfe.Localgames.GetVOPSSettingsInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetVOPSSettingsInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterVOPSReadyNotifications: BridgeCommands.Command<
    {},
    Types.Gfe.Localgames.RegisterVOPSReadyNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'RegisterVOPSReadyNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetBatteryBoostState: BridgeCommands.Command<
    {},
    Types.Gfe.Localgames.BatteryBoostState
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetBatteryBoostState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetBatteryBoostState: BridgeCommands.Command<
    Types.Gfe.Localgames.BatteryBoostState,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'SetBatteryBoostState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetBatteryBoostSupportState: BridgeCommands.Command<
    {},
    Types.Gfe.Localgames.GetBatteryBoostSupportStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetBatteryBoostSupportState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetWhisperModeState: BridgeCommands.Command<
    {},
    Types.Gfe.Localgames.WhisperModeState
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetWhisperModeState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetWhisperModeState: BridgeCommands.Command<
    Types.Gfe.Localgames.SetWhisperModeStateParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'SetWhisperModeState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterWhisperModeStateNotifications: BridgeCommands.Command<
    {},
    Types.Gfe.Localgames.WhisperModeState
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'RegisterWhisperModeStateNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetWhisperModeSupportState: BridgeCommands.Command<
    {},
    Types.Gfe.Localgames.FeatureSupportState
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetWhisperModeSupportState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterWhisperModeSupportStateNotifications: BridgeCommands.Command<
    {},
    Types.Gfe.Localgames.FeatureSupportState
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'RegisterWhisperModeSupportStateNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSettingsTranslations: BridgeCommands.Command<
    Types.Gfe.Localgames.GetSettingsTranslationsParameters,
    Types.Gfe.Localgames.GetSettingsTranslationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetSettingsTranslations',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSettingsSpace: BridgeCommands.Command<
    Types.Gfe.Localgames.GetSettingsSpaceParameters,
    Types.Gfe.Localgames.GetSettingsSpaceReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetSettingsSpace',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetTargetSettings: BridgeCommands.Command<
    Types.Gfe.Localgames.SetTargetSettingsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'SetTargetSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetApplicationState: BridgeCommands.Command<
    Types.Gfe.Localgames.GetApplicationStateParameters,
    Types.Gfe.Localgames.GetApplicationStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetApplicationState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterApplicationStateChangedNotifications: BridgeCommands.Command<
    {},
    Types.Gfe.Localgames.RegisterApplicationStateChangedNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'RegisterApplicationStateChangedNotifications',
    persistent: true
};

export const Localgames = {
GetApplications,
RegisterApplicationChangedNotifications,
RegisterApplicationRemovedNotifications,
StartApplicationScan,
RegisterApplicationScanProgressNotifications,
GetLastApplicationScanTime,
LaunchApplication,
GetLauncherPID,
GetApplicationSearchPaths,
AddApplicationSearchPath,
RemoveApplicationSearchPath,
GetVOPSStatus,
GetVOPSSettingsInfo,
RegisterVOPSReadyNotifications,
GetBatteryBoostState,
SetBatteryBoostState,
GetBatteryBoostSupportState,
GetWhisperModeState,
SetWhisperModeState,
RegisterWhisperModeStateNotifications,
GetWhisperModeSupportState,
RegisterWhisperModeSupportStateNotifications,
GetSettingsTranslations,
GetSettingsSpace,
SetTargetSettings,
GetApplicationState,
RegisterApplicationStateChangedNotifications
};
